// Actions
export const CREATE_LABEL = 'createLabel';
export const CREATE_PRINT_LABEL = 'createAndPrintLabel';

export const SHIPMENT_TYPES = {
  external: 'external',
  local: 'local',
  multiple: 'multiple',
  standard: 'standard',
};
